import React, { FC, useEffect } from "react";
import { 
  MediaService,  
  AuthService,
} from "../../../shared/services";
import { observer } from "mobx-react"; 
import { FlexContainer, Loader, PaginationModel, TablePagination } from "@mindmemobile/mm-shared-global";
import { MediaStore } from "../../../shared/store";
import { MediaGridResponseModel } from "../../../shared/models";

type IProps = {
  mediaStore: MediaStore;
};
const MediaGrid: FC<IProps> = ({ mediaStore }) => {
  const [showLoader, setShowLoader] = React.useState(true);
  useEffect(() => {
    loadData(
      mediaStore.pagination.pageNumber,
      mediaStore.pagination.pageSize,
      ""
    );
  }, []);

  function loadData(pageNumber: number, pageSize: number, searchValue: string) {
    MediaService.getMedias(
      AuthService.authData.accountId,
      pageNumber,
      pageSize,
      "image",
      searchValue
    ).subscribe({
      next: (response) => {
        setShowLoader(false);
        const medias = response.result?.map((m) => {
          return MediaGridResponseModel.deserializeAPIModel(m);
        });
        mediaStore.updateMedias(medias || []);
        const pagination = PaginationModel.deserialize(response.meta);
        mediaStore.updatePagination(pagination);
      },
    });
  }

  // const debounceSearch = debounce(
  //     () => loadData(mediaStore.pagination.pageNumber, mediaStore.pagination.pageSize, mediaStore.searchValue),
  //     500,
  // );

  function onPaginationChange(pageNumber: number, pageSize: number) {
    loadData(pageNumber, pageSize, mediaStore.searchValue);
  }

  if (showLoader) {
    return <> {new Loader(true).loaderComponent}</>;
  }

  return (
    <>
      <FlexContainer fxLayout="row" spacing={10}>
        {mediaStore.medias.map((m, idx) => {
          return (
            <div key={idx}>
              {m.type === "Image" && <img src={m.url} alt={m.name} />}
            </div>
          );
        })}
      </FlexContainer>
      <TablePagination
        onPageChange={(pageNumber: number) =>
          onPaginationChange &&
          onPaginationChange(pageNumber, mediaStore.pagination.pageSize)
        }
        onPageSizeChange={(pageSize: number) =>
          onPaginationChange && onPaginationChange(1, pageSize)
        }
        pagination={mediaStore.pagination}
      />
    </>
  );
};

export default observer(MediaGrid);
